import './styles.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';

const roots = document.querySelectorAll<HTMLElement>('[data-lens-bird-root]');

roots.forEach((rootElement) => {
  const launcher = rootElement.closest<HTMLElement>('[data-lens-bird-launcher]');

  if (!launcher) {
    return;
  }

  ReactDOM.createRoot(rootElement).render(<App launcher={launcher} />);
});
